export default "__VITE_ASSET__B2_$Svy2__"